import { jsx as i } from "react/jsx-runtime";
import { _ as u } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import y from "../RawButton/index.js";
import '../../index26.css';const m = "_button_1bxyf_1", b = "_round_1bxyf_31", d = "_primary_1bxyf_34", f = "_secondary_1bxyf_51", l = "_tertiary_1bxyf_69", t = {
  button: m,
  round: b,
  primary: d,
  secondary: f,
  tertiary: l
};
function B(r) {
  const {
    ariaLabel: o,
    children: n,
    className: a,
    variant: s = "tertiary",
    round: e = !0,
    ...c
  } = r, _ = u(
    t.button,
    t[s],
    e && t.round,
    a
  );
  return /* @__PURE__ */ i(
    y,
    {
      className: _,
      "aria-label": o,
      ...c,
      children: n
    }
  );
}
export {
  B as default
};
